const routes = {
  routes: {
    oldClientFolder: (folderName: string) => `/contracte/${folderName}`,

    root: '/',
    playground: '/playground',

    clientFiles: (folderName: string) => `/folders/${folderName}`,
    clientFolder: (folderName: string) => `/folders/${folderName}`,
    clientLogin: (folderName: string) => `/folders/${folderName}/access`,
    access: '/folders/access',
    folderFiles: (folderName: string, fileName: string) =>
      `/folders/${folderName}/files/${fileName}`,

    userFolders: (username: string) => `/${username}/folders`,
    editFileStructure: (username: string, folderId: string, fileId: string) =>
      `/${username}/folders/${folderId}/files/${fileId}/edit-structure`,
    editFileData: (username: string, folderName: string, fileId: string) =>
      `/${username}/folders/${folderName}/files/${fileId}/edit-data`,

    createDocument: (username: string, modelId: string) =>
      `/${username}/models/${modelId}/create`,
    dashboard: (username: string) => `/${username}/dashboard`,
    models: (username: string) => `/${username}/models`,
    newModel: (username: string) => `/${username}/models/new`,
    editModel: (username: string, modelId: string) =>
      `/${username}/models/${modelId}/edit`,
    uploads: (username: string) => `/${username}/uploads`,
    settings: (username: string) => `/${username}/settings`,
    notifications: (username: string) => `/${username}/notifications`,

    filters: {
      list: (username: string) => `/${username}/filters`,
      new: (username: string) => `/${username}/filters/new`,
      edit: (username: string, filterId: string) =>
        `/${username}/filters/${filterId}/edit`,
      view: (username: string, filterId: string) =>
        `/${username}/filters/${filterId}`,
    },

    queryFolders: {
      view: (username: string, filterId: string) =>
        `/${username}/query-folders/${filterId}`,
    },

    userLogin: '/users/login',
    userRegister: '/users/register',
  },

  root: '/',
  dashboard: (username: string) => `/${username}/dashboard`,
};

export default routes;
